export const adobeTags = {
  ON_PAGE_LOAD: (pageData) => {
    return {
      event: 'pageload',
      data: {
        pageName: pageData.pageName,
        siteSectionL1: pageData.siteSectionLevel.siteSectionLevel1,
        siteSectionL2: pageData.siteSectionLevel.siteSectionLevel2,
        siteSectionL3: pageData.siteSectionLevel.siteSectionLevel3,
        siteSectionL4: pageData.siteSectionLevel.siteSectionLevel4,
        siteSectionL5: pageData.siteSectionLevel.siteSectionLevel5,
        website: 'enhanced provider validation secure',
        businessUnit: 'uhc',
        referringSite: '',
        loginStatus: 'loggedin',
        language: 'English',
        providerGeo: '',
        providerDept: '',
        providerTitle: '',
        providerOrgType: '',
        providerRoleDescription: '',
        healthCareOrganization: '',
        providerAccountDesc: '',
        providerUuid: pageData.userInfo.uuid,
        providerTaxID: pageData.billingTin,
        providerMpin: '',
        providerBillingTaxID: pageData.billingTin,
      },
    };
  },
  ATTESTATION_PAGE_EDIT: (values) => {
    return {
      event: 'interaction',
      data: {
        interactionName: values.interactionName,
        interactionValue: values.interactionValue,
      },
    };
  },
  ATTESTATION_SUBMIT: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'attestation widget',
        interactionValue: 'submit',
      },
    };
  },
  ATTESTATION_COMPLETE: (values) => {
    return {
      event: 'jobCompleteTinRegistration',
      data: {
        jobName: 'tin registration',
        registrationType: values.practiceInfo.registrationTypeSelection,
        practiceType:
          values.practiceInfo.practiceTypeSelection?.value ||
          values.practiceInfo.practiceTypeSelection,
        primaryServiceAddressState:
          values.address.primaryServicing.state?.value ||
          values.address.primaryServicing.state,
        primaryServiceAddressZip: values.address.primaryServicing.zipCode,
        primaryServiceAddressCity: values.address.primaryServicing.city,
        referenceId: values.trackingNumber,
        providerUuid: values.userInfo.uuid,
        providerBillingTaxID: values.billingTin,
      },
    };
  },
  ATTESTATION_BACK: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'attestation widget',
        interactionValue: 'back',
      },
    };
  },
  DOWNLOAD_PDF: (values) => {
    return {
      event: 'download click',
      data: {
        downloadFileName: values.fileName,
      },
    };
  },
  START_TIN_REGISTRATION_STATUS: (values) => {
    return {
      event: 'tinStatusCheck',
      data: {
        searchBy: values.value,
      },
    };
  },
  TIN_REGISTRATION_START: () => {
    return {
      event: 'jobStartTinRegistration',
      data: {
        jobName: 'tin registration',
      },
    };
  },
  W9_UPLOAD_CONTINUE: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'w9 details widget',
        interactionValue: 'continue',
      },
    };
  },
  W9_UPLOAD_BACK: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'w9 details widget',
        interactionValue: 'back',
      },
    };
  },

  PRACTICE_DATA_CONTINUE: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Practice data widget',
        interactionValue: 'continue',
      },
    };
  },
  PRACTICE_DATA_BACK: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Practice data widget',
        interactionValue: 'back',
      },
    };
  },
  LOCATIONS_CONTINUE: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'locations widget',
        interactionValue: 'continue',
      },
    };
  },
  LOCATIONS_BACK: () => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'locations widget',
        interactionValue: 'back',
      },
    };
  },

  FORM_VALIDATION_ERROR: (data) => {
    return {
      event: 'formError',
      data: {
        errorMessage: 'Missing or invalid field(s)',
        errorFields: Object.keys(data.fields).join(','),
        errorType: 'form',
      },
    };
  },
  API_TRANSACTION_ERROR: (data) => {
    return {
      event: 'siteError',
      data: {
        errorMessage: data.message,
        errorApiCode: data.code,
        errorType: 'site',
      },
    };
  },
  EXIT_LINK_NAVIGATE: () => {
    return {
      event: 'exit click',
      data: {
        exitLink: 'form-W-9',
      },
    };
  },
  SAVE_AS_DRAFT: (data) => {
    return {
      event: data.eventInteraction,
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
      },
    };
  },
  SAVED_REGISTRATION: (data) => {
    return {
      event: data.eventInteraction,
      data: {
        jobName: data.jobName,
        registrationContext: data.registrationContext,
        providerBillingTaxID: data.providerBillingTaxID,
      },
    };
  },
  CLEAR_SIGNATURE: (data) => {
    return {
      event: data.eventInteraction,
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: data.interactionContext,
      },
    };
  },
  DELETE_REGISTRATION: (values) => {
    return {
      event: 'deleteTinRegistration',
      data: {
        providerUuid: values.uuid,
        providerBillingTaxID: values.billingTin,
      },
    };
  },
  VISIT_UHC_PROVIDER: () => {
    return {
      event: 'exit click',
      data: {
        exitLink: 'visit uhcprovider.com',
      },
    };
  },
  ACCOUNT_INFORMATION_CLICK: () => {
    return {
      event: 'exit click',
      data: {
        exitLink: 'account information',
      },
    };
  },
  COMMUNICATION_PREFERENCES_CLICK: () => {
    return {
      event: 'exit click',
      data: {
        exitLink: 'communication preferences',
      },
    };
  },
  SIGN_OUT_CLICK: () => {
    return {
      event: 'exit click',
      data: {
        exitLink: 'sign out',
      },
    };
  },
};
